import { getApiClient } from "@/api/clientRegistry";

const gatewayApi=getApiClient('gateway');
const commApi=getApiClient('commService');

export type generateOTP = {
    admission_number:string;
    captcha_token:string;
    isd_code:string;
    phone:string;
    product_id:number;
    tenant_id:number;
}

export type LoginWithPasswordPayload = {
    phone: string;
    password: string;
}

export type VerifyUsernamePayload = {
    username: string;
    captcha_token: string;
}

export type ForgotPasswordRequestOtpPayload = {
    username: string;
    captcha_token: string;
    product_id: number;
    tenant_id: number;
}

export type ForgotPasswordVerifyOtpPayload = {
    username: string;
    otp: string;
    product_id: number;
    tenant_id: number;
}

export type ResetPasswordPayload = {
    password: string
}

export const authService = {

    verifyPhoneNumber: async (obj: { dialCode: string; number: string }) => {
        const reqObj = {
            isd_code: obj.dialCode,
            phone: obj.number,
            admission_number: obj.number,
        };
        return gatewayApi.post("v1/user/agents/verify", reqObj);
    },

    requestotp: async(requestPayload:generateOTP)=>{
        return commApi.post("/generate-otp",requestPayload);
    },

    verifyOtp: async(requestPayload:generateOTP)=>{
        return gatewayApi.post("v1/user/agents/login-with-otp",requestPayload);
    },

    getLoginDto: async()=>{
        return gatewayApi.get("v1/user/agents/dto"
        );
    },

    loginWithPassword: async(requestPayload: LoginWithPasswordPayload)=>{
        return gatewayApi.post("v1/user/agents/login", requestPayload);
    },

    resetPassword: async(requestPayload: ResetPasswordPayload)=>{
        return gatewayApi.put("v1/user/agents/update-password", requestPayload);
    },
}